import { Environment } from './environment.interface';

/**
 * Staging/UAT Environment Configuration
 * 
 * This configuration is used for staging/UAT environment.
 * Run: ng build --configuration staging
 */
export const environment: Environment = {
  production: false, // Changed to false to enable debug mode in UAT
  appName: 'ScholarX (Staging)',
  baseUrl: 'https://staging.scholarx.irishtaylor.dev',
  nodeApiUrl: 'https://api.scholarx.irishtaylor.dev/node',
  pythonApiUrl: 'https://api.scholarx.irishtaylor.dev',
  apiTimeout: 30000,
  enableDebug: true, // Enable debug for UAT testing
  enableLogging: true, // Keep logging enabled in staging for debugging
  enableStudentThemes: false,
};

